import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const links = [
  ['Overview', 'overview'], ['Mission', 'mission'], ['What we build', 'build'], ['Approach', 'approach'],
  ['Principles', 'principles'], ['Story', 'story'], ['People', 'people'], ['Responsibility', 'responsibility'],
  ['References', 'references'], ['Future', 'future'],
]

export function AboutNav() {
  const [active, setActive] = useState('overview')
  useEffect(() => {
    const sections = links.map(([, id]) => document.getElementById(id)).filter(Boolean) as HTMLElement[]
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
      if (visible) setActive(visible.target.id)
    }, { rootMargin: '-18% 0px -68% 0px', threshold: [0, .1, .3] })
    sections.forEach((section) => observer.observe(section))
    return () => observer.disconnect()
  }, [])

  return <nav className="about-nav" aria-label="About section navigation"><div className="container"><Link to="/about">About</Link><div>{links.map(([label, id]) => <a className={active === id ? 'active' : ''} href={`#${id}`} key={id}>{label}</a>)}</div></div></nav>
}
